import  { mapGetters, mapActions } from 'vuex'
import LocalStorageService from '@/services/local-storage.service'
export default {
    methods: {
        ...mapActions('settings', ['sendDwhAction']),

        sendTrigger() {
            this.sendDwhAction({
                credentials: this.dwhCredentials,
                payload: {
                    user_id: this.user_id,
                    platform: 'web'
                }
            })
        }
    },
    computed: {
        ...mapGetters('auth', ['profile']),

        dwhCredentials() {
            return JSON.parse(LocalStorageService.get('settings')).dwh.value
        },
        user_id() {
            return this.profile.user_id
        }
    }
}